import { ref, toRef, reactive, computed, watch } from 'vue'
import { notification } from '@/helpers/notification'
import axios from 'axios'

export default function (props, { emit }) {
    const contacts = toRef(props, 'contacts')
    const renderContacts = ref([])
    const URLS = reactive({
        icons: {
            book: '/images/icons/calendar-star.svg',
            defaultContact: '/images/default-contact.svg',
            msgBubble: '/images/icons/chat-bubble.svg',
            vertKebab: '/images/icons/kebab-menu-vert.svg',
            addContact: '/images/icons/add-contact.svg'
        },
        mutate: {
            addArtistContact: '/api/profile/contacts/user/artist',
            addVenueContact: '/api/profile/contacts/user/venue',
            deleteContact: '/api/profile/contacts'
        },
        redirect: {
            book: '/booking-manager/#referred-by-contacts',
            createVenue: '/venues/create-new-profile'
        }
    })

    const showBookBtn = computed(() => (contact) => !!contact.artist_id)
    const contactKeywords = computed(() => (contact) => {
        if (!contact.keyword) return []
        return contact.keyword
            .split(',')
            .map((k) => k.trim())
            .slice(0, 2)
    })
    const subMenuItems = computed(() => (contact) => {
        let items = [
            {
                text: 'View profile',
                func: 'handleViewProfile'
            },
            // @TODO: remove comments once features are available
            // {
            //     text: 'Add to Favorites',
            //     func: 'handleAddToFavorites'
            // },
            {
                text: null,
                func: null
            },
            // {
            //     text: 'Block contact',
            //     func: 'handleBlockContact'
            // },
            {
                text: 'Remove contact',
                bold: true,
                func: 'handleRemoveContact'
            }
        ]

        return items
    })

    watch(
        () => props.contacts,
        (contacts) => {
            renderContacts.value = initContactsForView(contacts)
        }
    )

    renderContacts.value = initContactsForView(contacts.value)

    function initContactsForView(contacts) {
        let renderContacts = []

        for (let i = 0; i < contacts.length; i++) {
            renderContacts.push({
                ...contacts[i],
                showMenu: false
            })
        }

        return renderContacts
    }
    async function handleAddSuggestedContact(contact) {
        let postData = {}
        let url = ''

        switch (contact.role) {
            case 'venue':
                postData['venue_id'] = contact.id
                url = URLS.mutate.addVenueContact
                break

            case 'artist':
                postData['artist_id'] = contact.id
                url = URLS.mutate.addArtistContact
                break
        }

        try {
            let response = await axios.post(url, postData)
            emit('added-contact', contact)
            return response
        } catch (e) {
            notification('error', e)
        }
    }
    function handleViewProfile(contact) {
        let url

        if (contact.venue_name && contact.venue_id) {
            url = `/venues/${contact.slug}`
        } else {
            url = `/artists/${contact.slug}`
        }

        window.open(url, '_blank')
    }
    async function handleRemoveContact(contact) {
        let contactUserId = contact.artist_id ? contact.artist_id : contact.venue_id
        let role = contact.artist_id ? 'artist' : 'venue'

        try {
            let response = await axios.delete(`${URLS.mutate.deleteContact}/${role}/${contactUserId}`)

            emit('remove-contact', contact)
            return response
        } catch (e) {
            notification('error', e)
        }
    }
    function handleFilterKeyword(keyword) {
        emit('filter-keyword', keyword)
    }
    function toggleSubMenu(contacts, contact) {
        if (contact.showMenu) {
            return (contact.showMenu = false)
        }

        for (let i = 0; i < contacts.length; i++) {
            contacts[i].showMenu = false
        }

        return (contact.showMenu = true)
    }
    function handleSubMenuInvoke(contact, item) {
        contact.showMenu = false
        if (item.func === 'handleRemoveContact' || item.func === 'handleViewProfile') this[item.func](contact)
    }
    function handleBookContact(user, contact) {
        if (user.bookingVenue) {
            localStorage.setItem('artistEmail', contact.band_email)
            window.location.href = URLS.redirect.book
        } else {
            window.location.href = URLS.redirect.createVenue
        }
    }

    return {
        URLS,
        renderContacts,
        showBookBtn,
        contactKeywords,
        subMenuItems,
        initContactsForView,
        toggleSubMenu,
        handleFilterKeyword,
        handleSubMenuInvoke,
        handleBookContact,
        handleRemoveContact,
        handleViewProfile,
        handleAddSuggestedContact
    }
}
